import { useParams } from "react-router-dom";
import { SaleService } from "./Service";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomerService } from "../customer/Service";
import converter from "number-to-words";

const COMPANY = {
  name: "Anand Apparels",
  gst: "08ACSPP4164C1ZD",
  address:
    "Shop No. 1-2, Near Power House, Jhalawar Road, Kota - 324007 (Raj.)",
  email: "anandhardware468@gmail.com",
  mobile: "+91 7976124354",
  logo: "/assets/img/logo.jpg",
  bank: {
    name: "HDFC Bank",
    account: "50200099803432",
    ifsc: "HDFC0007039",
    branch: "",
  },
};

const TERMS = [
  "Breakage during transport is not the responsibility of the distributer. No claims will be provided.",
  "No return will be entertained.",
  "No complaints will be entertained once the goods are out of godown.",
  "All the dues are to be cleared within 30 days of the delivery.",
];

// Here place the necessary variables and also the products
const SaleInvoice = () => {
  const { id }: any = useParams();
  const service = new SaleService();
  const [customerService] = useState(new CustomerService());
  const admin = useSelector((state: any) => state.auth);

  // Variables
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [customer, setCustomer] = useState<any>(null);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [saleMode, setSaleMode] = useState<{
    label: string;
    value: string;
  } | null>(null);
  const [amountReceived, setAmountReceived] = useState(0);
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [comments, setComments] = useState("");
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const [products, setProducts] = useState<any[]>([]);
  const [taxableAmount, setTaxableAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [roundOff, setRoundOff] = useState(false);
  const [enableTax, setEnableTax] = useState(false);
  const [recurringInvoice, setRecurringInvoice] = useState(false);
  const [igstAmount, setIgstAmount] = useState(0);
  const [freight, setFreight] = useState(0);
  const [saleTax, setSaleTax] = useState<any>(null);

  useEffect(() => {
    const loadDetails = async () => {
      const sale = await service.getSale(parseInt(id!));
      if (sale) {
        setInvoiceNumber(sale.invoiceNumber);
        setCustomer(sale.customer);
        // Format date in d-m-Y
        const dateObj = new Date(sale.invoiceDate);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        setInvoiceDate(`${day}-${month}-${year}`);
        // setDueDate(sale.dueDate.split("T")[0].toString());
        setSaleMode({ label: sale.saleMode, value: sale.saleMode });
        setAmountReceived(sale.amountReceived);
        setModeOfPayment(sale.modeOfPayment);
        setComments(sale.comments);
        setDiscount(sale.discount);
        setProducts(
          sale.products.map((p: any) => ({
            ...p.product,
            quantity: p.quantity,
            salePrice: p.salePrice,
            discount: p.discount ?? 0,
            hsn: p.product.hsn || "",
            variant: p.variant,
          }))
        );
        setEnableTax(sale.enableTax);
        setRecurringInvoice(sale.recurringInvoice);
        setSaleTax(sale.tax);
        loadCustomerDetails(sale.customer.id);
        setFreight(parseFloat(sale.freight) || 0);
      }
    };
    loadDetails();
    // eslint-disable-next-line
  }, []);

  const loadCustomerDetails = async (cusId: number) => {
    customerService.get(cusId).then((res: any) => {
      if (res) {
        setCustomer(res);
      }
    });
  };

  useEffect(() => {
    // Calculate taxable amount (includes individual product discounts)
    const taxableAmount = products.reduce((acc: number, product: any) => {
      return (
        acc +
        product.quantity * product.salePrice -
        (product.quantity * product.salePrice * product.discount) / 100
      );
    }, 0);
    setTaxableAmount(roundOff ? Math.round(taxableAmount) : taxableAmount);

    // Calculate overall discount on taxable amount
    const totalDiscount = discount > 0 ? (taxableAmount * discount) / 100 : 0;
    setTotalDiscount(roundOff ? Math.round(totalDiscount) : totalDiscount);

    // Calculate IGST on (taxableAmount - totalDiscount)
    const taxPercentage = saleTax?.percentage ?? 0;
    const igst = ((taxableAmount - totalDiscount) * taxPercentage) / 100;
    setIgstAmount(roundOff ? Math.round(igst) : igst);

    // Final total: taxableAmount + igst - totalDiscount + freight
    const finalTotal = taxableAmount + igst - totalDiscount + freight;
    setTotal(roundOff ? Math.round(finalTotal) : finalTotal);
  }, [products, roundOff, discount, freight, saleTax]);

  const formatAddress = (address: any) => {
    return `${address?.addressLine1 ? address.addressLine1 + ", " : ""}${
      address?.addressLine2 ? address.addressLine2 + ", " : ""
    }${address?.city ? address.city + ", " : ""}${
      address?.state ? address.state + ", " : ""
    }${address?.country ? address.country + ", " : ""}${
      address?.zipCode ? address.zipCode : ""
    }`;
  };

  const capitalizeInitials = (str: string) => {
    return str.replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const getHSN = (product: any) => product.hsn || product.HSN || "";
  const getStateCode = (gstin: string) => (gstin ? gstin.substring(0, 2) : "");
  const amountInWords = capitalizeInitials(converter.toWords(total)) + " Only.";

  // Do not disturb the template below
  return (
    <table
      style={{
        borderCollapse: "collapse",
        marginLeft: "6.0pt",
        color: "#000",
        padding: "10px 10px",
        width: "200mm",
      }}
      cellSpacing={0}
    >
      <tbody style={{ padding: "10px 10px" }}>
        {/* Company and Invoice Header */}
        <tr>
          <td colSpan={9} style={{ border: "1pt solid #DDDDDD" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>
                <img
                  src={COMPANY.logo}
                  alt={COMPANY.name}
                  style={{ height: 60 }}
                />
                <div style={{ fontWeight: "bold", fontSize: 18 }}>
                  {COMPANY.name}
                </div>
                <div>GST No.: {COMPANY.gst}</div>
                <div>{COMPANY.address}</div>
                <div>
                  Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
                  | Mobile: {COMPANY.mobile}
                </div>
              </div>
              <div style={{ textAlign: "right", marginRight: "10px" }}>
                <div style={{ fontWeight: "bold", fontSize: 22 }}>
                  Tax Invoice
                </div>
                <div>Invoice No.: {invoiceNumber}</div>
                <div>Date: {invoiceDate}</div>
                {/* <div>Due Date: {dueDate}</div> */}
                {/* <div>Sale Mode: {saleMode?.label}</div> */}
              </div>
            </div>
          </td>
        </tr>
        {/* Bill To */}
        <tr>
          <td
            colSpan={9}
            style={{ border: "1pt solid #DDDDDD", padding: "10px 10px" }}
          >
            <div style={{ fontWeight: "bold", fontSize: 16, marginBottom: 4 }}>
              Bill To
            </div>
            {customer && (
              <div>
                <div style={{ fontWeight: "bold" }}>{customer.name}</div>
                {/* Show billing address if available */}
                <div>
                  {(() => {
                    const billing =
                      customer.addresses?.find(
                        (a: any) => a.type === "Shipping"
                      ) || customer.addresses?.[0];
                    return billing ? formatAddress(billing) : "";
                  })()}
                </div>
                {/* Show contact number */}
                <div>
                  {customer.phoneNumber && (
                    <>Contact No.: {customer.phoneNumber}</>
                  )}
                </div>
                {/* Show GSTIN if available */}
                <div>
                  {customer.company?.gstNumber && (
                    <>
                      GSTIN: {customer.company.gstNumber} | State Code:{" "}
                      {getStateCode(customer.company.gstNumber)}
                    </>
                  )}
                </div>
              </div>
            )}
          </td>
        </tr>
        {/* Shipping Address */}
        <tr>
          <td
            colSpan={9}
            style={{ border: "1pt solid #DDDDDD", padding: "10px 10px" }}
          >
            <div style={{ fontWeight: "bold", fontSize: 16, marginBottom: 4 }}>
              Shipping Address
            </div>
            {customer && (
              <div>
                {/* Show shipping address if available */}
                <div>
                  {(() => {
                    const shipping =
                      customer.addresses?.find(
                        (a: any) => a.type === "Shipping"
                      ) || customer.addresses?.[0];
                    return shipping ? formatAddress(shipping) : "";
                  })()}
                </div>
              </div>
            )}
          </td>
        </tr>
        {/* Products Table Header */}
        <tr style={{ padding: "10px 10px" }}>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "8mm",
            }}
          >
            #
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "45mm",
            }}
          >
            Product
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "18mm",
            }}
          >
            HSN
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "12mm",
            }}
          >
            Qty
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "18mm",
            }}
          >
            Rate
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "14mm",
            }}
          >
            Discount (%)
          </td>
          <td
            style={{
              border: "1pt solid #DDDDDD",
              fontWeight: "bold",
              padding: "10px 10px",
              width: "20mm",
            }}
          >
            Amount
          </td>
        </tr>
        {/* Products Rows */}
        {products.length === 0 ? (
          <tr>
            <td
              colSpan={7}
              style={{ textAlign: "center", border: "1pt solid #DDDDDD" }}
            >
              No products found.
            </td>
          </tr>
        ) : (
          products.map((product, idx) => {
            const productDiscount = product.discount ?? 0;
            const productTax = product.tax?.percentage ?? 0;
            const baseAmount = product.quantity * product.salePrice;
            const discountAmount = (baseAmount * productDiscount) / 100;
            const taxableAmount = baseAmount - discountAmount;
            const taxAmount = (taxableAmount * productTax) / 100;
            const totalAmount = taxableAmount + taxAmount;
            return (
              <tr key={idx} style={{ padding: "10px 10px" }}>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "center",
                    padding: "10px 10px",
                  }}
                >
                  {idx + 1}
                </td>
                <td
                  style={{ border: "1pt solid #DDDDDD", padding: "10px 10px" }}
                >
                  <div>{product.name}</div>
                  {product.variant && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#000",
                        marginTop: "2px",
                      }}
                    >
                      {product.variant.size} {product.variant.unit} -{" "}
                      {product.variant.type}
                    </div>
                  )}
                </td>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "center",
                    padding: "10px 10px",
                  }}
                >
                  {product.code}
                </td>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "center",
                    padding: "10px 10px",
                  }}
                >
                  {product.quantity}
                </td>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "right",
                    padding: "10px 10px",
                  }}
                >
                  ₹{product.salePrice.toFixed(2)}
                </td>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "right",
                    padding: "10px 10px",
                  }}
                >
                  {productDiscount}%
                </td>
                <td
                  style={{
                    border: "1pt solid #DDDDDD",
                    textAlign: "right",
                    padding: "10px 10px",
                  }}
                >
                  ₹{taxableAmount.toFixed(2)}
                </td>
              </tr>
            );
          })
        )}

        {/* HSN/SAC Summary Table and Totals Side by Side */}
        <tr>
          <td colSpan={7} style={{ border: "1pt solid #DDDDDD", padding: "0" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  {/* Left side - HSN/SAC Table */}
                  <td
                    style={{ width: "60%", verticalAlign: "top", padding: "0" }}
                  >
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <tbody>
                        {/* HSN/SAC Header */}
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            HSN/SAC
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            Taxable Value
                          </td>
                          <td
                            colSpan={2}
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            CGST
                          </td>
                          <td
                            colSpan={2}
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            SGST
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "5px",
                              textAlign: "center",
                            }}
                          >
                            Total Amount
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              padding: "3px",
                            }}
                          ></td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              padding: "3px",
                            }}
                          ></td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                          >
                            Rate
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                          >
                            Amount
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                          >
                            Rate
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              fontWeight: "bold",
                              padding: "3px",
                              textAlign: "center",
                              fontSize: "11px",
                            }}
                          >
                            Amount
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              padding: "3px",
                            }}
                          ></td>
                        </tr>

                        {/* HSN/SAC Data Rows */}
                        {(() => {
                          // Group products by HSN
                          const hsnGroups = products.reduce(
                            (acc: any, product: any) => {
                              const hsn = getHSN(product);
                              if (!acc[hsn]) {
                                acc[hsn] = {
                                  hsn,
                                  taxableValue: 0,
                                  taxRate: saleTax?.percentage ?? 0,
                                  products: [],
                                };
                              }
                              // Calculate product's taxable amount after individual discount
                              const productTaxable =
                                product.quantity * product.salePrice -
                                (product.quantity *
                                  product.salePrice *
                                  (product.discount ?? 0)) /
                                  100;
                              // Apply overall discount proportion to this product's taxable amount
                              const productAfterOverallDiscount =
                                productTaxable -
                                (productTaxable * discount) / 100;
                              acc[hsn].taxableValue +=
                                productAfterOverallDiscount;
                              acc[hsn].products.push(product);
                              return acc;
                            },
                            {}
                          );

                          return Object.values(hsnGroups).map(
                            (group: any, idx: number) => {
                              const centralTaxRate = group.taxRate / 2;
                              const stateTaxRate = group.taxRate / 2;
                              const centralTaxAmount =
                                (group.taxableValue * centralTaxRate) / 100;
                              const stateTaxAmount =
                                (group.taxableValue * stateTaxRate) / 100;
                              const totalAmount =
                                group.taxableValue +
                                centralTaxAmount +
                                stateTaxAmount;

                              return (
                                <tr key={idx}>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "center",
                                      padding: "5px",
                                    }}
                                  >
                                    8302
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "right",
                                      padding: "5px",
                                    }}
                                  >
                                    {group.taxableValue.toFixed(2)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "center",
                                      padding: "5px",
                                    }}
                                  >
                                    {centralTaxRate}%
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "right",
                                      padding: "5px",
                                    }}
                                  >
                                    {centralTaxAmount.toFixed(2)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "center",
                                      padding: "5px",
                                    }}
                                  >
                                    {stateTaxRate}%
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "right",
                                      padding: "5px",
                                    }}
                                  >
                                    {stateTaxAmount.toFixed(2)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1pt solid #DDDDDD",
                                      textAlign: "right",
                                      padding: "5px",
                                    }}
                                  >
                                    {totalAmount.toFixed(2)}
                                  </td>
                                </tr>
                              );
                            }
                          );
                        })()}

                        {/* HSN/SAC Total Row */}
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "center",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            Total
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {(taxableAmount - totalDiscount).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "center",
                              padding: "5px",
                            }}
                          ></td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {(igstAmount / 2).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "center",
                              padding: "5px",
                            }}
                          ></td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {(igstAmount / 2).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {(
                              taxableAmount -
                              totalDiscount +
                              igstAmount
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  {/* Right side - Summary Totals */}
                  <td
                    style={{ width: "40%", verticalAlign: "top", padding: "0" }}
                  >
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            Sub-Total:
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            {taxableAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            Discount:
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            {totalDiscount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {saleTax?.name || "Tax"} ({saleTax?.percentage || 0}
                            %):
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            {igstAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            Freight:
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              padding: "5px",
                            }}
                          >
                            {freight.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            Total Amount:
                          </td>
                          <td
                            style={{
                              border: "1pt solid #DDDDDD",
                              textAlign: "right",
                              fontWeight: "bold",
                              padding: "5px",
                            }}
                          >
                            {total.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        {/* Amount in Words */}
        <tr>
          <td
            colSpan={7}
            style={{
              border: "1pt solid #DDDDDD",
              fontStyle: "italic",
              padding: "10px 10px",
            }}
          >
            Amount in Words: {amountInWords}
          </td>
        </tr>
        {/* Bank Details */}
        <tr>
          <td
            colSpan={7}
            style={{ border: "1pt solid #DDDDDD", padding: "10px 10px" }}
          >
            <div>
              <strong>Bank Name:</strong> {COMPANY.bank.name},{" "}
              <strong>A/C No.:</strong> {COMPANY.bank.account}{" "}
              <strong>IFSC:</strong> {COMPANY.bank.ifsc}
            </div>
            {COMPANY.bank.branch && (
              <div>
                <strong>Branch:</strong> {COMPANY.bank.branch}
              </div>
            )}
          </td>
        </tr>
        {/* Terms and Conditions */}
        <tr>
          <td
            colSpan={7}
            style={{ border: "1pt solid #DDDDDD", padding: "10px 10px" }}
          >
            <div style={{ fontWeight: "bold", marginBottom: 4 }}>
              Terms and Conditions
            </div>
            <ol>
              {TERMS.map((term, idx) => (
                <li key={idx} style={{ marginBottom: 2 }}>
                  {term}
                </li>
              ))}
            </ol>
          </td>
        </tr>
        {/* Authorised Signatory */}
        <tr>
          <td
            colSpan={7}
            style={{
              border: "1pt solid #DDDDDD",
              textAlign: "right",
              padding: "10px 10px",
            }}
          >
            <div>For {COMPANY.name}</div>
            <div style={{ marginTop: 32 }}>Authorised Signatory</div>
          </td>
        </tr>
        {/* Footer */}
        <tr>
          <td
            colSpan={7}
            style={{
              border: "1pt solid #DDDDDD",
              textAlign: "center",
              fontStyle: "italic",
              padding: "10px 10px",
            }}
          >
            This is a computer generated invoice.
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default SaleInvoice;
